module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/Users/sameer/Documents/projects/release/metabase/node_modules/babel-loader/lib/index.js?{\"cacheDirectory\":\".babel_cache\"}!/Users/sameer/Documents/projects/release/metabase/node_modules/eslint-loader/index.js!/Users/sameer/Documents/projects/release/metabase/frontend/src/metabase/lib/ga-metadata.js"));
    });
  });
}


//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/promise-loader?global!./lib/ga-metadata.js
// module id = 860
// module chunks = 0 3 5